import { z } from 'zod';

const accountNotesSchema = z.object({
  id: z.number().positive(),
  accountNotes: z
    .string()
    .max(20001, { message: 'Account Notes must not exceed 20,000 characters.' })
    .optional(),
  arNotes: z
    .string()
    .max(20001, { message: 'A/R must not exceed 20,000 characters.' })
    .optional(),
});

export type AccountNotesSchema = z.infer<typeof accountNotesSchema>;

export type AccountNoteErrors = {
  [K in keyof AccountNotesSchema]?: string;
}

export const AccountNotes = () =>
  ({
    accountNotesSchema,
  })
;
